import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {ScrollSection} from 'components/ScrollSpy'
import {useAccommodationPageScrollTopOffset} from 'hooks/useAccommodationPageScrollTopOffset'
import {getMetaBrandHasRooms} from 'modules/accommodation/selectors'
import {AccommodationPageNavSections} from 'modules/accommodation/types'
import {getHotelRoomsData} from 'modules/searchApi/selectors'

import {Box} from '@vio/atlas/src/components/designSystem/helpers/Box'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {cssTheme} from '@vio/atlas/src/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {RoomCard} from '../RoomCard'

const Wrapper = styled.div<{isMobile?: boolean}>`
  padding-left: ${({isMobile}) =>
    isMobile ? cssTheme.layout.spacing.s400 : cssTheme.layout.spacing.s000};
  padding-right: ${({isMobile}) =>
    isMobile ? cssTheme.layout.spacing.s400 : cssTheme.layout.spacing.s000};
  padding-top: ${({isMobile}) =>
    isMobile ? cssTheme.layout.spacing.s600 : cssTheme.layout.spacing.s000};
  padding-bottom: ${({isMobile}) =>
    isMobile ? cssTheme.layout.spacing.s600 : cssTheme.layout.spacing.s000};
  background-color: ${cssTheme.colors.background.neutral.secondary};
`

export const DatelessRoomSection = ({hotelId}: {hotelId: string}) => {
  const scrollOffset = useAccommodationPageScrollTopOffset()
  const {isMobile} = useDeviceLayout()
  const brandHasRooms = useSelector(getMetaBrandHasRooms)
  const rooms = useSelector(state => getHotelRoomsData(state, hotelId))

  if (!rooms.length || !brandHasRooms) return null

  return (
    <ScrollSection
      name={AccommodationPageNavSections.Rooms}
      scrollTopMargin={scrollOffset}
      dataId={'DatelessRoomSection'}
    >
      <Wrapper isMobile={isMobile}>
        <Text variant={isMobile ? 'titleL' : 'titleXL'}>
          <FormattedMessageWrapper
            id="roomsList.roomOptionsTitle"
            defaultMessage="Room options"
          />
        </Text>
        <Box display="flex" flexDirection="column" gap="s500" paddingTop="s600">
          {rooms.map(room => (
            <RoomCard key={room.id} hotelId={hotelId} room={room} isDateless />
          ))}
        </Box>
      </Wrapper>
    </ScrollSection>
  )
}
